module.exports = __webpack_public_path__ + "img/google_map.e26414d0.png";